import type { $Fetch, NitroFetchRequest } from "nitropack";
export const useApiClient = (type: "staff" | "donor" = "donor") => {
  if (type === "staff") {
    return useNuxtApp().$staffApi as $Fetch<unknown, NitroFetchRequest>;
  }
  return useNuxtApp().$api as $Fetch<unknown, NitroFetchRequest>;
};
